/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useCallback, useEffect, VFC } from "react";
import { Box, Flex, Heading, Spacer, useDisclosure } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { MenuIconButton } from "../../atoms/button/MenuIconButton";
import { MenuDrawer } from "../../molecules/MenuDrawer";
import { useLoginUser } from "../../../hooks/useLoginUser";
import appconfig from '../../../config_app.json';

export const Header: VFC = memo(() => {
  const loginUser = useLoginUser();
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  const longinUserName = loginUser ? loginUser.loginUser?.userName : "";
  const navigate = useNavigate();

  const SYSTEM_TITLE: string = appconfig["SYSTEM_TITLE"];

  const onClickHome = useCallback(() => navigate("/"), []);
  const onClickRegistTenant = useCallback(() => navigate("/home/regist"), []);
  const onClickTenants = useCallback(() => navigate("/home/tenants"), []);
  const onClickUsers = useCallback(() => navigate("/home/users"), []);
  const onClickGroups = useCallback(() => navigate("/home/groups"), []);
  const onClickLoginout = useCallback(() => {
    if (loginUser.isLoggedIn) {
      loginUser.logout();
    }
    navigate("/");
  }, []);

  var onClickEditTenant = ()=>{navigate("/home/tenant/" + (loginUser ? loginUser.loginUser?.tenant : ""));};
  useEffect(()=>{
    onClickEditTenant = ()=>{navigate("/home/tenant/" + (loginUser ? loginUser.loginUser?.tenant : ""));};
  },[loginUser]);

  return (
    <>
      <Flex
        as="nav"
        bg="teal.500"
        color="gray.50"
        align="center"
        justify="space-between"
        padding={{ base: 3, md: 5 }}
        top={0}
        position="fixed"
        w={"full"}
        h={{base:"50px", md:"60px"}}
        zIndex={10}
      >
        <Flex
          align="center"
          as="a"
          mr={8}
          _hover={{ cursor: "pointer", color:"yellow" }}
          onClick={onClickHome}
        >
          <Heading as="h1" fontSize={{ base: "md", md: "lg" }}>
          {SYSTEM_TITLE}
          </Heading>
        </Flex>
        <Flex
          align="center"
          fontSize="sm"
          display={{ base: "none", md: "flex" }}
          flexGrow={2}
        >
        {loginUser.isLoggedIn ? 
          <>
            <Box p={1} mr={3} _hover={{ cursor: "pointer", color:"yellow" }} onClick={onClickUsers}>ユーザー</Box>
            <Box p={1} mr={3} _hover={{ cursor: "pointer", color:"yellow" }} onClick={onClickGroups}>グループ</Box>
            <Box p={1} mr={3} _hover={{ cursor: "pointer", color:"yellow" }} onClick={onClickEditTenant}>センサー</Box>
            {loginUser.loginUser?.isAccountAdmin ? 
              <>
                <Box p={1} mr={3} _hover={{ cursor: "pointer", color:"yellow" }} onClick={onClickTenants}>市町村</Box>
                <Box p={1} mr={3} _hover={{ cursor: "pointer", color:"yellow" }} onClick={onClickRegistTenant}>市町村追加</Box>
              </>
            :
              <></>
            }
            <Spacer/>
            <Box p={1} mr={3} _hover={{ cursor: "pointer", color:"yellow" }}  onClick={onClickLoginout}>
              <Box textAlign={"right"}>
                {loginUser.isLoggedIn ? "ログアウト" : "ログイン"}
              </Box>
              <Box ml={2} display={{ base: "none", md: "none", lg:"flex"}} fontSize="sm">
                {loginUser.isLoggedIn ? longinUserName : ""}
              </Box>
            </Box>
          </>
        : 
          <></>
        }
        </Flex>
        {loginUser.isLoggedIn ? 
          <MenuIconButton onOpen={onOpen} />
          :  
          <></>
        }
      </Flex>
      <Flex
        w={"full"}
        mt={{base:"50px", md:"60px"}}
      />
      <MenuDrawer
        isOpen={isOpen}
        onClose={onClose}
        onClickHome={onClickHome}
        onClickEditTenant={onClickEditTenant}
        onClickRegistTenant={onClickRegistTenant}
        onClickTenants={onClickTenants}
        onClickUsers={onClickUsers}
        onClickGroups={onClickGroups}
        onClickLogin={onClickLoginout}
        onClickLogout={onClickLoginout}
          />
    </>
  );
});
